/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { DatePicker, Radio, Select } from 'antd';

import {
  Area,
  Bar,
  TableComponent,
  Guage,
  GridGuage,
  Pie,
  Polar,
  // PieRose,
  SingleLineDiagram,
  Donut,
  Counter,
  CompassGuage,
  Funnel,
  CandleStick,
  SingleBar,
  Line,
  ProgressBar,
  //Regression,
  PieBar,
  BubbleChart,
  //CandleStickBrush,
  TreeGraph,
  //BoxPlot,
  BeijingLine,
  // LiquidGuage,
  SingleCandleStick,
  BarTable,
  StatusCounter,
  Scatter,
  HeatmapCartesion,
  HeatmapCartesionTable,
  HeatmapCalendar,
  ConfusionMatrix,
  DottedBar,
  PieSingleLine,
  PieLine,
  CardsList,
  WindBarb,
  StackedBar,
  StackedLine,
  //FeedbackTable,
  ImageGalleryWithPreview,
  LiveStreaming,
  GuageRing,
  GuageRingWithCounter,
  NotificationTable,
  //SelectImageDetails,
  // PieNestComponent,
  LineTable,
  SliderStatus,
  GuageLine,
  NotificationScatter,
  LineBarArea,
  CounterLine,
  GeoMap,
  // SunBurst,
  DonutCounter,
  CountersPie,
  Video,
  LineTableCounter,
  Report,
  Image,
  LineWithSelection,
  Predictions,DashboardInDash
} from '../ChartComponents';
import localStorage from '../../../utils/localStorage';
import moment from 'moment';
import { DateSelection } from './CSS/styles';


const { MonthPicker, WeekPicker, RangePicker } = DatePicker;
const { Option } = Select;

const Graph = (props) => {
  let { graphprops } = props;
  let selectionPoint =
    graphprops &&
      graphprops.GraphLevelSelectionPoint &&
      graphprops.GraphLevelSelectionPoint === 'PreviousDay'
      ? '1'
      : '0';
  let tb = graphprops.GraphLevelTimeBucket;
  const [state, setState] = useState(() => ({
    graphprops,
    currentDate: dayjs(),
    currentTab: 'Day',
    week: dayjs().startOf('week'),
    month: dayjs().format('MMMM'),
    year: dayjs().year()
  }));

  const [DeviceCode, setDeviceCode] = useState('');
  const [selectionDate, setSelectionDate] = useState(dayjs().subtract(selectionPoint, 'day').format('YYYY-MM-DD HH:mm:ss'));
  const [selectionMonth, setSelectionMonth] = useState(dayjs().format('YYYY-MM'));
  const [selectionDateRange, setSelectionDateRange] = useState(
    {
      startDate: dayjs()
        .subtract(selectionPoint, 'day')
        .subtract(1, 'hour')
        .format('YYYY-MM-DD HH:mm:ss'),
      endDate: dayjs().subtract(selectionPoint, 'day').format('YYYY-MM-DD HH:mm:ss')
    }
  );
  const [dayMonthYear, setDayMonthYear] = useState(
    {
      StartDate: dayjs().subtract(selectionPoint, 'day').format('YYYY-MM-DD 00:00:00'),
      EndDate: dayjs().subtract(selectionPoint, 'day').format('YYYY-MM-DD 23:59:59'),
      TimeBucket: tb && tb['Day'] ? tb['Day'] : "",
      SelectionType: 'Day'
    }
  );
  

  const [optionList, setOptionList] = useState([]);
  const [yearValue, setYearValue] = useState('');

  const updateState = (update) => {
    setState((prev) => ({ ...prev, ...update }));
  };

  useEffect(() => {
    let { graphprops } = props;
    let defaultSelection = selectionPoint;
    let dayMonthYear;

    if (
      graphprops &&
      graphprops.deviceGraphSelection &&
      graphprops.deviceGraphSelection === 'true'
    ) {
      getOptionList();
    }

    if (graphprops.DashboardLevelSelection !== 'none') {
      defaultSelection =
        graphprops &&
          graphprops.DashboardLevelSelectionPoint &&
          graphprops.DashboardLevelSelectionPoint === 'PreviousDay'
          ? '1'
          : '0';
    } else if (graphprops.GraphLevelSelection !== 'none') {
      defaultSelection =
        graphprops &&
          graphprops.GraphLevelSelectionPoint &&
          graphprops.GraphLevelSelectionPoint === 'PreviousDay'
          ? '1'
          : '0';
    }
    if (
      graphprops &&
      graphprops.GraphLevelSelection === 'dateMonthYearPicker' &&
      graphprops.GraphLevelTimeBucket &&
      Object.keys(graphprops.GraphLevelTimeBucket).length > 0
    ) {
      let tb = graphprops.GraphLevelTimeBucket;
      if (Object.keys(tb)[0] === 'Day') {
        dayMonthYear = {
          StartDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD 00:00:00'),
          EndDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD HH:mm:ss'),
          TimeBucket: tb['Day'],
          SelectionType: 'Day'
        };
      } else if (Object.keys(tb)[0] === 'Week') {
        dayMonthYear = {
          StartDate: dayjs().format('YYYY-MM-DD 00:00:00'),
          EndDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD HH:mm:ss'),
          TimeBucket: tb['Week'],
          SelectionType: 'Week'
        };
      } else if (Object.keys(tb)[0] === 'Month') {
        dayMonthYear = {
          StartDate: dayjs().format('YYYY-MM-DD 00:00:00'),
          EndDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD HH:mm:ss'),
          TimeBucket: tb['Month'],
          SelectionType: 'Month'
        };
      } else if (Object.keys(tb)[0] === 'Year') {
        dayMonthYear = {
          StartDate: dayjs().format('YYYY-MM-DD 00:00:00'),
          EndDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD HH:mm:ss'),
          TimeBucket: tb['Year'],
          SelectionType: 'Year'
        };
      }
      updateState({ dayMonthYear });
    }
  }, []);

  const onChangeDatePicker = (value, dateString) => {
    setSelectionDate(moment(dateString).format('YYYY-MM-DD 00:00:00'));
  };

  const onDateRangePickerChange = (currentDate) => {
    let selectionDateRange = {};
    if (currentDate && currentDate[0] && currentDate[1]) {
      selectionDateRange = {
        startDate: currentDate[0].format('YYYY-MM-DD HH:mm:ss'),
        endDate: currentDate[1].format('YYYY-MM-DD HH:mm:ss')
      };
    }
    setSelectionDateRange(selectionDateRange);
  };

  const onChangeMonthPicker = (value, dateString) => {
    setSelectionMonth(dateString);
  };

  const disabledDate = (current) => {
    let { graphprops } = props;
    let selectionPoint = '0';
    if (graphprops && graphprops.DashboardLevelSelection !== 'none') {
      selectionPoint =
        graphprops &&
          graphprops.DashboardLevelSelectionPoint &&
          graphprops.DashboardLevelSelectionPoint === 'PreviousDay'
          ? '1'
          : '0';
    } else if (graphprops && graphprops.GraphLevelSelection !== 'none') {
      selectionPoint =
        graphprops &&
          graphprops.GraphLevelSelectionPoint &&
          graphprops.GraphLevelSelectionPoint === 'PreviousDay'
          ? '1'
          : '0';
    }
    return current > dayjs().startOf('day').subtract(selectionPoint, 'day');
  };

  const disabledDateRangePicker = (current) => {
    const { graphprops } = props;
    const now = dayjs();

    // 1. Determine selectionPoint
    const selectionPoint = (
      (graphprops?.DashboardLevelSelectionPoint === 'PreviousDay') ||
      (graphprops?.GraphLevelSelectionPoint === 'PreviousDay')
    ) ? 1 : 0;

    // 2. Calculate cutoff date
    const cutoffDate = dayjs().startOf('day').subtract(selectionPoint, 'day');

    // 3. Disable conditions
    return current.isAfter(cutoffDate, 'day') ||  // Future dates
      (current.isSame(cutoffDate, 'day') &&      // Same day check
        current.isAfter(now, 'minute'));          // Future times on cutoff day
  };

  const onChange = async (date) => {
    
    let { graphprops } = props;
    let selectionPoint =
      graphprops &&
        graphprops.GraphLevelSelectionPoint &&
        graphprops.GraphLevelSelectionPoint === 'PreviousDay'
        ? '1'
        : '0';

    let startDateSelected = dayjs(date).format('YYYY-MM-DD 00:00:00');
    let endDateSelected = dayjs(date).format('YYYY-MM-DD 23:59:59');

    let timeBucketObject =
      props && props.graphprops && props.graphprops.GraphLevelTimeBucket
        ? props.graphprops.GraphLevelTimeBucket
        : {};
    let payload = {
      StartDate: dayjs(startDateSelected)
        .subtract(selectionPoint, 'day')
        .format('YYYY-MM-DD HH:mm:ss'),
      EndDate: dayjs(endDateSelected)
        .subtract(selectionPoint, 'day')
        .format('YYYY-MM-DD HH:mm:ss'),
      SelectionType: 'Day',
      TimeBucket: timeBucketObject['Day']
    };
    setDayMonthYear(payload);

  };

  const onRadioChange = (e) => {
    let panelId = props && props.graphprops && props.graphprops.id
      ? props.graphprops.id
      : null;
    if (e && e.target && e.target.value === 'Month') {
      let currentMonth = dayjs().format('MMMM');
      let currentYear = dayjs().year();
      handleMenuClick(currentMonth, 'Month', panelId);
      updateState({
        currentTab: e.target.value,
        month: currentMonth,
        year: currentYear
      });
    } else if (e && e.target && e.target.value === 'Year') {
      let currentYear = dayjs().year();
      handleMenuClick(currentYear, 'Year', panelId);
      updateState({
        currentTab: e.target.value,
        year: currentYear
      });
    } else if (e && e.target && e.target.value === 'Week') {
      let currentWeek = dayjs().startOf('isoWeek');
      handleMenuClick(currentWeek, 'Week', panelId);
      updateState({
        currentTab: e.target.value,
        week: currentWeek
      });
    } else if (e && e.target && e.target.value === 'Day') {
      onChange(dayjs(), panelId);
      updateState({
        currentTab: e.target.value
      });
    } else {
      onChange(dayjs(), panelId);
      updateState({
        currentTab: e.target.value
      });
    }
  };

  const handleMenuClick = async (value, tabType) => {
    let payload = {};
    let GraphLevelSelectionPoint =
      graphprops &&
        graphprops.GraphLevelSelectionPoint &&
        graphprops.GraphLevelSelectionPoint === 'PreviousDay'
        ? '1'
        : '0';

    let timeBucketObject =
      graphprops && graphprops.inputGraphFields ? graphprops.inputGraphFields : {};
    let selectedMonth = null;
    if (tabType === 'Month') {
      selectedMonth = dayjs(value, 'MMMM').month();
      const currentYearVal = yearValue === '' ? dayjs().year() : yearValue;
      const startDate = dayjs(`${currentYearVal}-${selectedMonth + 1}-01`, 'YYYY-M-D').startOf('month');
      let endDate = dayjs(`${currentYearVal}-${selectedMonth + 1}-01`, 'YYYY-M-D').endOf('month');

      if (
        currentYearVal === dayjs().year() &&
        selectedMonth === dayjs().month()
      ) {
        endDate = dayjs().subtract(GraphLevelSelectionPoint, 'day');
      }

      payload = {
        StartDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
        EndDate: endDate.format('YYYY-MM-DD HH:mm:ss'),
        TimeBucket: timeBucketObject['Month'],
        SelectionType: 'Month'
      };
    } else if (tabType === 'Year' || tabType === 'MonthYear') {
      const startDate = dayjs(`${value}-${selectedMonth + 1}-01`).startOf('month');
      let endDate = dayjs(`${value}-${selectedMonth + 1}-01`).endOf('month');
      const startDateYear = dayjs(`${value}-01-01`).startOf('year');
      let endDateYear = dayjs(`${value}-12-31`).endOf('year');

      if (value === dayjs().year()) {
        endDate = dayjs().subtract(GraphLevelSelectionPoint, 'day');
      }
      const currentYear = dayjs().year();
      payload = {
        StartDate: tabType === 'MonthYear' ? startDate.format('YYYY-MM-DD HH:mm:ss') : startDateYear.format('YYYY-MM-DD HH:mm:ss'),
        EndDate: value === currentYear ||  tabType === 'MonthYear' ? endDate.format('YYYY-MM-DD HH:mm:ss'):endDateYear.format('YYYY-MM-DD HH:mm:ss'),
        TimeBucket: tabType === 'MonthYear' ? timeBucketObject['Month'] : timeBucketObject['Year'],
        SelectionType: tabType === 'MonthYear' ? 'Month' : 'Year'
      };
      setYearValue(value);
    } else if (tabType === 'Week') {
      let currentWeek = dayjs().startOf('isoWeek');
      payload = {
        StartDate: dayjs(value).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
        EndDate: value.isSame(currentWeek)
          ? dayjs().subtract(GraphLevelSelectionPoint, 'day').format('YYYY-MM-DD HH:mm:ss')
          : dayjs(value).endOf('week').format('YYYY-MM-DD HH:mm:ss'),
        TimeBucket: timeBucketObject['Week'],
        SelectionType: 'Week'
      };
    }
    setDayMonthYear(payload);
  };

  const renderGraph = (graphprops) => {

    let graphNewProps = {
      ...props,
      ...(props.graphprops.deviceGraphSelection === 'true' ? { DeviceCode } : {}),
      ...(props.graphprops.GraphLevelSelection === 'datePicker' ? { selectionDate } : {}),
      ...(props.graphprops.GraphLevelSelection === 'monthPicker' ? { selectionMonth } : {}),
      ...(props.graphprops.GraphLevelSelection === 'dateRangePicker' ? { selectionDateRange } : {}),
      ...(props.graphprops.GraphLevelSelection === 'dateMonthYearPicker' ? { dayMonthYear } : {}),
    };
    switch (graphprops.graph) {
      case 'area':
        return <Area {...graphNewProps} />;
      case 'bar':
        return <Bar {...graphNewProps} />;
      case 'guage':
        return <Guage {...graphNewProps} />;
      case 'GridGuage':
        return <GridGuage {...graphNewProps} />;
      case 'singleBar':
        return <SingleBar {...graphNewProps} />;
      case 'image':
        return <SingleLineDiagram {...graphNewProps} />;
      case 'counter':
        return <Counter {...graphNewProps} />;
      case 'counterLine':
        return <CounterLine {...graphNewProps} />;
      case 'compassGuage':
        return <CompassGuage {...graphNewProps} />;
      case 'table':
        return <TableComponent {...graphNewProps} />;
      case 'candleStick':
        return <CandleStick {...graphNewProps} />;
      case 'line':
        return <Line {...graphNewProps} />;
      case 'progressBar':
        return <ProgressBar {...graphNewProps} />;
      case 'funnel':
        return <Funnel {...graphNewProps} />;
      case 'donut':
        return <Donut {...graphNewProps} />;
      case 'pie':
        return <Pie {...graphNewProps} />;
      case 'polar':
        return <Polar {...graphNewProps} />;
      // case 'pieRose':
      //   return <PieRose {...graphNewProps} />;
      // case 'regression':
      //   return <Regression {...graphNewProps} />;
      case 'pieBar':
        return <PieBar {...graphNewProps} />;
      case 'bubbleChart':
        return <BubbleChart {...graphNewProps} />;
      // case 'candleStickBrush':
      //  return <CandleStickBrush {...graphNewProps} />;
      case 'treeGraph':
        return <TreeGraph {...graphNewProps} />;
      case 'DashboardInDashboard':
        return <DashboardInDash {...graphNewProps} />;
      // case 'boxPlot':
      //   return <BoxPlot {...graphNewProps} />;
      // case 'liquidGuage':
      //   return <LiquidGuage {...graphNewProps} />;
      case 'beijingLine':
        return <BeijingLine {...graphNewProps} />;
      case 'singleCandleStick':
        return <SingleCandleStick {...graphNewProps} />;
      case 'barTable':
        return <BarTable {...graphNewProps} />;
      case 'lineTable':
        return <LineTable {...graphNewProps} />;
      case 'statusCounter':
        return <StatusCounter {...graphNewProps} />;
      case 'scatter':
        return <Scatter {...graphNewProps} />;
      case 'HeatmapCartesion':
        return <HeatmapCartesion {...graphNewProps} />;
      case 'HeatmapCartesionTable':
        return <HeatmapCartesionTable {...graphNewProps} />;
      case 'heatmapCalendar':
        return <HeatmapCalendar {...graphNewProps} />;
      case 'confusionMatrix':
        return <ConfusionMatrix {...graphNewProps} />;
      case 'dottedBar':
        return <DottedBar {...graphNewProps} />;
      case 'guageLine':
        return <GuageLine {...graphNewProps} />;
      case 'pieSingleLine':
        return <PieSingleLine {...graphNewProps} />;
      case 'pieLine':
        return <PieLine {...graphNewProps} />;
      case 'cardsList':
        return <CardsList {...graphNewProps} />;
      case 'windBarb':
        return <WindBarb {...graphNewProps} />;
      case 'stackedBar':
        return <StackedBar {...graphNewProps} />;
      case 'stackedLine':
        return <StackedLine {...graphNewProps} />;
      // case 'feedbackTable':
      //   return <FeedbackTable {...graphNewProps} />;
      case 'ImageGalleryWithPreview':
        return <ImageGalleryWithPreview {...graphNewProps} />;
      case 'liveStreaming':
        return <LiveStreaming {...graphNewProps} />;
      case 'GuageRing':
        return <GuageRing {...graphNewProps} />;
      case 'GuageRingWithCounter':
        return <GuageRingWithCounter {...graphNewProps} />;
      case 'notificationTable':
        return <NotificationTable {...graphNewProps} />;
      // case 'selectImageDetails':
      //   return <SelectImageDetails {...graphNewProps} />;
      // case 'pieNest':
      //   return <PieNestComponent {...graphNewProps} />;
      case 'sliderStatus':
        return <SliderStatus {...graphNewProps} />;
      case 'notificationScatter':
        return <NotificationScatter {...graphNewProps} />;
      case 'LineBarArea':
        return <LineBarArea {...graphNewProps} />;
      case 'GeoMap':
        return <GeoMap {...graphNewProps} />;
      // case 'SunBurst':
      //   return <SunBurst {...graphNewProps} />;
      case 'DonutCounter':
        return <DonutCounter {...graphNewProps} />;
      case 'CountersPie':
        return <CountersPie {...graphNewProps} />;
      case 'Video':
        return <Video {...graphNewProps} />;
      case 'LineTableCounter':
        return <LineTableCounter {...graphNewProps} />;
      case 'Report':
        return <Report {...graphNewProps} />;
      case 'Image':
        return <Image {...graphNewProps} />;
      case 'LineWithSelection':
        return <LineWithSelection {...graphNewProps} />;
      case 'Predictions':
        return <Predictions {...graphNewProps} />;

      default:
        return <div>{`Graph Doesn't exists`}</div>;
    }
  };

  const getOptionList = () => {
    let accessToken = localStorage.get('accessToken');
    let siteId = localStorage.get('currentSite');

    let url = '';
    let payload1 = props.graphprops.apiPayloadDeviceSelection || {};
    if (payload1 && payload1.method === 'GET' && payload1.GETParams) {
      url = `${payload1.url}?SiteId=${siteId}&${payload1.GETParams}`;
    } else {
      url = `${payload1.url}?SiteId=${siteId}`;
    }
    let payloadSelectedDevice = payload1.payload || '';
    const ObjectHeader = {
      method: payload1.method,
      url,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: payloadSelectedDevice || {}
    };
    axios(ObjectHeader).then((response) => {
      if (response.data) {
        let optionList = response.data;
        let deviceCode = optionList && Array.isArray(optionList) && optionList[0] ? optionList[0].Value : '';
        setOptionList(optionList);
        setDeviceCode(props.graphprops.deviceMultiSelect === true ? deviceCode : deviceCode);
        setState({
          ...state.deviceGraphSelection,
          DeviceCode: props.graphprops.deviceMultiSelect === true ? deviceCode : deviceCode
        });
      }
    });
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  if (dayjs().year() > 2020) {
    var yearList = [];
    for (var i = 2020; i <= dayjs().year(); i++) {
      yearList.push(i);
    }
    yearList.sort((a, b) => b - a);
  }

  let {  currentTab } = state;
  return (
    <span>

      {props.graphprops.GraphLevelSelection === 'datePicker' ? (
        <DateSelection>
          <DatePicker
            format="YYYY-MM-DD"
            value={dayjs(selectionDate)}
            onChange={onChangeDatePicker}
            disabledDate={disabledDate}
            allowClear={false}
          />
        </DateSelection>
      ) : null}

      {props.graphprops.GraphLevelSelection === 'monthPicker' ? (
        <DateSelection>
          <MonthPicker
            style={{ marginTop: '10px', marginRight: '10px' }}
            disabledDate={disabledDate}
            placeholder="Select Month"
            onChange={onChangeMonthPicker}
            format="YYYY-MM"
            allowClear={false}
            value={dayjs(selectionMonth)}
          />
        </DateSelection>
      ) : null}

      {props.graphprops.GraphLevelSelection === 'dateRangePicker' ? (
        <DateSelection>
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm:ss"
            placeholder={['Start Date', 'End Date']}
            onChange={onDateRangePickerChange}
            value={[
              dayjs(
                selectionDateRange
                  ? selectionDateRange.startDate
                  : undefined
              ),
              dayjs(
                selectionDateRange
                  ? selectionDateRange.endDate
                  : undefined
              )
            ]}
            allowClear={false}
            style={{
              width: '400px',
              cursor: 'pointer'
            }}
            disabledDate={disabledDateRangePicker}
          />
        </DateSelection>
      ) : null}

      {props.graphprops.GraphLevelSelection === 'dateMonthYearPicker' ? (
        <DateSelection>
          <Radio.Group
            value={currentTab}
            onChange={onRadioChange}
            style={{ marginLeft: '20px' }}
          >
            {Object.keys(props.graphprops.inputGraphFields) ? (
              <>
                {Object.keys(props.graphprops.inputGraphFields).map((GraphType, index) => {
                  return (
                    <Radio.Button key={index} value={GraphType}>
                      {translation(GraphType)}
                    </Radio.Button>
                  );
                })}
              </>
            ) : null}
          </Radio.Group>

          {currentTab === 'Day' ? (
            <DatePicker
              onChange={onChange}
              value={dayjs(dayMonthYear && dayMonthYear.EndDate ? dayMonthYear.EndDate : undefined)}
              disabledDate={disabledDate}
              allowClear={false}
            />
          ) : null}
          {currentTab === 'Week' ? (
            <WeekPicker
              value={dayjs(
                dayMonthYear && dayMonthYear.StartDate
                  ? dayMonthYear.StartDate
                  : undefined
              )}
              style={{ width: '200px' }}
              disabledDate={disabledDate}
              placeholder="Select Week"
              onChange={(e) => handleMenuClick(e, 'Week')}
              allowClear={false}
            />
          ) : null}
          {currentTab === 'Month' ? (
            <>
              <Select
                value={
                  dayMonthYear && dayMonthYear.EndDate
                    ? dayjs(dayMonthYear.EndDate).format('MMMM')
                    : undefined
                }
                onChange={(e) => handleMenuClick(e, 'Month')}
                style={{ width: '100px' }}
              >
                {dayjs.months().map((value, index) => {
                  return (
                    <Option key={index} value={value}>
                      {value}
                    </Option>
                  );
                })}
              </Select>
              <Select
                value={
                  dayMonthYear && dayMonthYear.EndDate
                    ? dayjs(dayMonthYear.EndDate).format('YYYY')
                    : undefined
                }
                onChange={(e) => handleMenuClick(e, 'MonthYear')}
                style={{ width: '100px' }}
              >
                {yearList && Array.isArray(yearList) && yearList.map((value, index) => {
                  return (
                    <Option key={index} value={value}>
                      {value}
                    </Option>
                  );
                })}
              </Select>
            </>
          ) : null}

          {currentTab === 'Year' ? (
            <Select
              value={
                dayMonthYear && dayMonthYear.EndDate
                  ? dayjs(dayMonthYear.EndDate).format('YYYY')
                  : undefined
              }
              onChange={(e) => handleMenuClick(e, 'Year')}
              style={{ width: '100px' }}
            >
              {yearList && Array.isArray(yearList) && yearList.map((value, index) => {
                return (
                  <Option key={index} value={value}>
                    {value}
                  </Option>
                );
              })}
            </Select>
          ) : null}
        </DateSelection>
      ) : null}

      {props.graphprops.deviceGraphSelection === 'true' ? (
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Select
            onChange={(DeviceCode) =>
              setDeviceCode(DeviceCode) ||
              setState({
                ...state,
                DeviceCode
              })
            }
            value={DeviceCode}
            style={{ width: 220, height: 50, padding: '10px 8px' }}
          >
            {optionList &&
              Array.isArray(optionList) &&
              optionList.map((device, index) => {
                console.log(device,'device');
                return (
                  <Select.Option key={index} value={device.Value}>
                    {device.Key}
                  </Select.Option>
                );
              })}
          </Select>
        </div>
      ) : null}

      {renderGraph(props.graphprops)}
    </span>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(Graph);
